import {AccountBatchSearchCriteria, AccountBatchSortField} from 'web-angular-client';

export class AccountBatchSearchCriteriaImpl implements AccountBatchSearchCriteria
{
    batchNumber?: number;
    batchName?: string;
    accountBatchSortField?: AccountBatchSortField;
    dateTimeCreatedLower?: string;
    dateTimeCreatedUpper?: string;
    totalRequestsLower?: number;
    totalRequestsUpper?: number;

    constructor()
    {
        this.batchNumber = null;
        this.batchName = null;
        this.accountBatchSortField = null;
        this.dateTimeCreatedLower = null;
        this.dateTimeCreatedUpper = null;
        this.totalRequestsLower = null;
        this.totalRequestsUpper = null;
    }
}